module.exports = __webpack_public_path__ + "img/header.52603bb8.png";